"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoBar = void 0;
var LogoBar = /** @class */ (function () {
    function LogoBar(container, itemsPerPage) {
        if (itemsPerPage === void 0) { itemsPerPage = 4; }
        this.container = container;
        this.itemsPerPage = itemsPerPage;
        this.items = [];
        this.pages = [];
        this.activePage = 0;
        this.scrollContainer = this.getElement('.logo-bar__scroll-container');
        this.logoContainer = this.getElement('.logo-bar__container');
        this.pagination = this.getElement('.logo-bar__pagination');
        this.init();
    }
    LogoBar.prototype.getElement = function (selector) {
        var element = this.container.querySelector(selector);
        if (!element)
            throw new Error("Element ".concat(selector, " wurde nicht gefunden."));
        return element;
    };
    LogoBar.prototype.createElement = function (tag, className, parent) {
        var element = document.createElement(tag);
        element.className = className;
        if (parent)
            parent.appendChild(element);
        return element;
    };
    LogoBar.prototype.init = function () {
        this.items = Array.from(this.logoContainer.querySelectorAll('.logo-bar__item'));
        if (!this.items.length)
            return;
        this.buildPages();
        this.renderPagination();
        this.bindEvents();
        this.bindPaginationEvents();
    };
    LogoBar.prototype.buildPages = function () {
        this.scrollContainer.innerHTML = '';
        this.scrollContainer.tabIndex = -1;
        this.pages = [];
        var _loop_1 = function (i) {
            var page = this_1.createElement('ul', "".concat(this_1.logoContainer.className, " logo-bar__page"), this_1.scrollContainer);
            var slice = this_1.items.slice(i, i + this_1.itemsPerPage);
            slice.forEach(function (item) { return page.appendChild(item); });
            this_1.pages.push(page);
        };
        var this_1 = this;
        for (var i = 0; i < this.items.length; i += this.itemsPerPage) {
            _loop_1(i);
        }
    };
    LogoBar.prototype.bindEvents = function () {
        var _this = this;
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var index = _this.pages.indexOf(entry.target);
                    if (index !== -1 && index !== _this.activePage) {
                        _this.activePage = index;
                        _this.renderPagination();
                    }
                }
            });
        }, { root: this.scrollContainer, threshold: 0.6 });
        this.pages.forEach(function (page) { return observer.observe(page); });
    };
    LogoBar.prototype.bindPaginationEvents = function () {
        var _this = this;
        this.pagination.addEventListener('click', function (e) {
            var target = e.target;
            if (target.classList.contains('logo-bar__pagination-bullet')) {
                var index = Array.from(_this.pagination.children).indexOf(target);
                _this.goToPage(index);
            }
        });
    };
    LogoBar.prototype.goToPage = function (page) {
        var target = this.pages[page];
        this.scrollContainer.scrollTo({
            left: target.offsetLeft,
            behavior: 'smooth',
        });
    };
    LogoBar.prototype.renderPagination = function () {
        var _this = this;
        this.pagination.innerHTML = '';
        var paginationLabel = this.pagination.dataset.paginationLabel || '';
        var paginationSwitchLabel = this.pagination.dataset.paginationLabelSwitch || '';
        this.pages.forEach(function (_, i) {
            var btn = _this.createElement('button', 'logo-bar__pagination-bullet', _this.pagination);
            btn.setAttribute('data-index', i.toString());
            var ariaLabel = [paginationLabel, "".concat(i + 1), paginationSwitchLabel].filter(Boolean).join(' ');
            btn.setAttribute('aria-label', ariaLabel);
            btn.setAttribute('type', 'button');
            btn.setAttribute('aria-current', i === _this.activePage ? 'true' : 'false');
            btn.classList.toggle('active', i === _this.activePage);
        });
    };
    return LogoBar;
}());
exports.LogoBar = LogoBar;
